import { Controller } from "@hotwired/stimulus"

// Client-side task toggling for the logged-out demo — state lives in sessionStorage.
export default class extends Controller {
    static targets = []

    connect() {
        this._loadState()
        this.element.querySelectorAll("[data-task-row]").forEach((row) => {
            let id = row.dataset.taskId
            if (this._completed.has(id)) {
                row.classList.add("is-completed")
                row.dataset.completed = "true"
            }
            this._syncCollapseRow(row)
        })
    }

    toggleComplete(e) {
        let row = e.currentTarget.closest("[data-task-row]")
        if (!row) return
        let id = row.dataset.taskId
        let completed = row.classList.toggle("is-completed")
        row.dataset.completed = completed ? "true" : "false"
        if (completed) this._completed.add(id)
        else this._completed.delete(id)
        this._saveState()
    }

    toggleCollapse(e) {
        let row = e.currentTarget.closest("[data-task-row]")
        if (!row) return
        let next = row.dataset.collapsed !== "true"
        this._syncCollapseRow(row, next)
    }

    _syncCollapseRow(row, collapsed = row.dataset.collapsed === "true") {
        row.dataset.collapsed = collapsed ? "true" : "false"
        let block = row.closest("[data-task-block]")
        let children = block?.querySelector(".tasks-outline-children")
        if (children) children.classList.toggle("is-collapsed", collapsed)
    }

    _loadState() {
        try {
            let raw = sessionStorage.getItem("demo_tasks_completed")
            this._completed = new Set(raw ? JSON.parse(raw) : [])
        } catch {
            this._completed = new Set()
        }
    }

    _saveState() {
        try {
            sessionStorage.setItem("demo_tasks_completed", JSON.stringify([...this._completed]))
        } catch {
            // sessionStorage unavailable — ignore
        }
    }
}
